<template>
  <div class="animated fadeIn">
    <b-modal
      title="Choose period"
      class="modal-primary"
      v-model="shippedModal"
      @ok="fetchChartDataReceived(), shippedModal = false"
    >
      <b-form>
        <b-form-group label="From" label-for="date" :label-cols="3">
          <!--          <b-form-input v-model="shippedDateFrom" type="date" id="date"></b-form-input>-->
          <datepicker use-utc
            value-format="MM/dd/yyyy"
            :bootstrap-styling="true"
            v-model="dateFrom"
            name="dateFrom"
          ></datepicker>
        </b-form-group>
        <b-form-group label="To" label-for="dateTo" :label-cols="3">
          <!--          <b-form-input v-model="shippedDateTo" type="date" id="dateTo"></b-form-input>-->
          <datepicker use-utc
            value-format="MM/dd/yyyy"
            :bootstrap-styling="true"
            v-model="dateTo"
            name="dateTo"
          ></datepicker>
        </b-form-group>
      </b-form>
    </b-modal>

    <b-row>
      <b-col lg="12">
        <b-card class="citiesBar" header="Shipped">
          <div slot="header">
            <h5 style="display: inline;" class="card-title mb-0">
              Turn Around Time Analytics
              <small>
                {{ from ? $formatUSDate(from) : $formatUSDate(dateFrom) }}
                <b>|</b>
                {{ to ? $formatUSDate(to) : $formatUSDate(dateTo) }}
              </small>
            </h5>
            <!--            Central division spent rate (top 10 Cities)-->
            <div class="card-header-actions">
              <b-button
                class="btn"
                style="height: 26px; width: 26px"
                variant="transparent p-0"
                attr="pdf"
                @click="downloadPDF()"
              >
                <i class="fa fa-file-pdf-o" style="color: rgb(32, 168, 216);" aria-hidden="true"></i>
              </b-button>
              <b-button
                @click="citiesModalEvent"
                class
                style="height: 26px; width: 26px"
                variant="transparent p-0"
              >
                <i class="icon-calendar" style="color: #20a8d8;"></i>
              </b-button>
              <b-button
                @click="toggleFullScreenCities"
                style="height: 26px; width: 26px"
                class="float-right"
                variant="transparent p-0"
                right
              >
                <i style="color: #20a8d8;" class="icon-frame"></i>
              </b-button>
            </div>
          </div>

          <div class="chart-wrapper">
            <div
              style="height: 400px; padding-top: 150px"
              v-if="loadingTopLocations"
              class="loading"
            >
              <b-row>
                <b-col lg="12">
                  <div class="sk-double-bounce">
                    <div class="sk-child sk-double-bounce1"></div>
                    <div class="sk-child sk-double-bounce2"></div>
                  </div>
                </b-col>
              </b-row>
              <!--/.row-->
            </div>
            <highcharts
              ref="citiesRef"
              v-else
              :options="barOptions"
              class="chart"
              :constructor-type="'chart'"
            ></highcharts>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cTable from "./TableClean.vue";
import HighCharts from "vue-highcharts";
import Datepicker from "vuejs-datepicker";

export default {
  props: ["location", "productGroup", "type", "date_from", "date_to", "prg"],
  name: "tables",
  components: { cTable, HighCharts, Datepicker },
  data: () => {
    return {
      locationParam: "",
      locationsIds: "",
      productGroupParam: "",
      dateFrom: "",
      dateTo: "",
      title: "",
      loading: true,
      shippedModal: false,

      loadingTopLocations: false,
      barOptions: {
        chart: {
          type: "column",
          backgroundColor: "transparent"
        },
        exporting: {
          enabled: true
        },
        title: {
          text: ""
        },
        xAxis: {
          labels: {
            style: {
              color: "white"
            }
          },
          categories: []
        },
        yAxis: {
          labels: {
            style: {
              color: "white"
            }
          },
          min: 0,
          title: {
            text: "category"
          }
        },
        yAxis: {
          title: {
            text: "Days"
          }
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            stacking: "normal",
            point: {
              events: {
                click: ({ point }) => {
                  this.topCitiesModal = true;
                  this.fetchChartDataCityPerProductGroup(point.category);
                  this.cityPerPrGroupModalTitle = point.category;
                  console.log(point);
                  // router.push('/base/Tables/?location=' + point.category + '&productGroup=&type=top&date_from=' + this.topLocationsDateFrom + '&date_to=' + this.topLocationsDateTo)
                }
              }
              // events: {
              //   click: function () {
              //     alert(this.topCitiesModal)
              //     this.topCitiesModal = true
              //     // router.push('/base/Tables/?location=' + this.category + '&productGroup=&type=top&date_from=' + this.topLocationsDateFrom + '&date_to=' + this.topLocationsDateTo)
              //      alert('Category: ' + this.category)
              //   }
              // }
            }
          }
        },
        series: [
          {
            name: "Turn Around Time By Products",
            data: []
          }
        ]
      },
      data: [],
      fields: [
        { key: "Power Supply", label: "Power Supply" },
        { key: "Meter", label: "Meter" },
        { key: "Line Gear", label: "Line Gear" },
        { key: "Transponder", label: "Transponder" },
        { key: "Fiber Gear", label: "Fiber Gear" }
      ]
    };
  },
  methods: {
    citiesModalEvent() {
      if (this.fullscreenCities) {
        this.toggleFullScreenCities();
        this.shippedModal = 1;
      } else {
        this.shippedModal = 1;
      }
    },
    toggleFullScreenCities() {
      this.$fullscreen.toggle(this.$el.querySelector(".citiesBar"), {
        wrap: false,
        callback: this.fullscreenChangeCities
      });
    },
    fetchChartDataReceived() {
      this.loadingTopLocations = true;
      let params = {};
      this.dateFrom = this.from ? this.from : this.dateFrom;
      this.dateTo = this.to ? this.to : this.dateTo;

      params = {
        date_from: this.dateFrom,
        date_to: this.dateTo
      };
      this.$http
        .get("api/charts/tat.php", {
          params
        })
        .then(
          res => {
            this.data = res.data;
            this.loading = false;
            let myArray = res.data;
            let xAxis = [];
            let yAxis = [];
            var myData = res.data[0];
            var sortable = [];

            for (var type in myData) {
              sortable.push([type, myData[type]]);
            }
            sortable.sort((a, b) => (parseInt(a[1]) > parseInt(b[1]) ? -1 : 1));

            sortable.forEach(obj => {
              xAxis.push(obj[0]);
              yAxis.push(parseFloat(obj[1]));
            });

            // res.data.forEach(obj => {
            //   Object.entries(obj).forEach(([key, value]) => {
            //     xAxis.push(`${key}`);
            //     yAxis.push(parseFloat(`${value}`));
            //   });
            // });

            this.barOptions.xAxis.categories = xAxis;
            this.barOptions.series[0].data = yAxis;
            this.loadingTopLocations = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    downloadPDF() {
      this.$refs.citiesRef.chart.options.title.text =
        "Turn Around Time | " +
        (this.from ? this.from : this.dateFrom) +
        " - " +
        (this.to ? this.to : this.dateTo);

      this.$refs.citiesRef.chart.options.title.style.display = "block";
      this.$refs.citiesRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";

      this.$refs.citiesRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });
      console.log(this.$refs.citiesRef.chart);
      this.$refs.citiesRef.chart.exportChart({
        type: "application/pdf",
        filename:
          "TAT-" +
          (this.from ? this.from : this.dateFrom) +
          "-" +
          (this.to ? this.to : this.dateTo)
      });

      this.$refs.citiesRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
    }
  },
  computed: {
    from() {
      if (typeof this.dateFrom === "object") {
        this.dateFrom = this.dateFrom.toISOString().split("T")[0];
        return this.dateFrom;
      }
    },
    to() {
      if (typeof this.dateTo === "object") {
        this.dateTo = this.dateTo.toISOString().split("T")[0];
        return this.dateTo;
      }
    }
  },
  mounted() {
    if (!localStorage.getItem("alpha_user")) {
      router.push("/pages/login/");
    }
    this.locationsIds = localStorage.getItem("locations");

    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.title = "Table Product By Day Summary";
    this.fetchChartDataReceived();
  }
};
</script>
<style>
.complaintClass {
  width: 200px;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
